import React, { Component } from 'react'
import './style.scss'
import classNames from 'classnames'


// import asset from './images/social-twitter.svg'
const asset = 'https://i.annihil.us/u/prod/avengersmovie/guardians/static/media/social-twitter.ee6a5ea9.svg'

export default class Twitter extends Component {


  handleClick(e){
    if(this.props.share){
      this.handleShare()
      e.preventDefault()
    }
  }

  handleShare() {
    var tweetbegin = "https://twitter.com/intent/tweet?url="
    var url = window.location.origin + this.props.url
    var tweet = '#BecomeTheWildCard '
    tweet = url + '&text=' + encodeURIComponent(tweet)

    var finaltweet = tweetbegin + tweet
    window.open(finaltweet, "_blank", "width=535, height=360")
  }

  render() {
    let classes = classNames({
      'twitter': true,
      'social-icon': true
    })
    let href = !this.props.share ? this.props.url : '#'
    return (
      <div className={classes} style={this.props.styles}><a href={href} target="_blank" onClick={this.handleClick.bind(this)}>
        <img src={asset} alt=""/>
      </a></div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/react.SocialContainer/react.twitter/index.js